import { useQuery,useMutation } from 'react-query';

import { CalendarUsers, UserResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

type UserOptions = {
  id?: number;
  page?: number;
  perPage?: number;
};
export const getCalenderUsers = ({ id, page, perPage }: UserOptions = { }): Promise<UserResponse> => {
  return axios.get(`/business/${id}/users/all`, {
    params: {page,perPage},
  });
};


type UseOptions = {
  config?: MutationConfig<typeof getCalenderUsers>;
};

export const useGetCalenderUsers= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCalenderUsers,
  });
};